/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Free_DescriptionInputs */

const en_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few papers, every week.`)
};

const es_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unos cuantos artículos, cada semana.`)
};

/**
* | output |
* | --- |
* | "A few papers, every week." |
*
* @param {Pricing_Free_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_free_description = /** @type {((inputs?: Pricing_Free_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Free_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_free_description(inputs)
	return en_pricing_free_description(inputs)
});